import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Event, EventCategory } from '../model';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private api_prefix: string;

  constructor(private http: HttpClient) {
    this.api_prefix = environment.backEndUrl + "/events";
  }

  createSingleEvent(event: Event): Observable<any> {
    let url = this.api_prefix;
    return this.http.post(url, event);
  }

  updateSingleEvent(event: Event, uuid: string) {
    let url = this.api_prefix + `/${uuid}`;
    return this.http.put(url, event);
  }

  deleteSingleEvent(uuid: string) {
    let url = this.api_prefix + `/${uuid}`;
    return this.http.delete(url);
  }

  getAllEvents(active_only: boolean = false, shipId?: string ): Observable<Array<Event>> {
    let url = this.api_prefix;

    let params: HttpParams = new HttpParams();
    params = params = params.set("active_only", active_only);

    if(shipId) params = params.set("ship_id", shipId);

    return this.http.get<Array<Event>>(url, { params: params })
  }


  getEvent(uuid: string): Observable<Event> {
    let url = this.api_prefix + `/${uuid}`;
    return this.http.get<Event>(url);
  }

  getAllCategories(): Observable<Array<EventCategory>> {
    let url = this.api_prefix + `/categories`;
    return this.http.get<Array<EventCategory>>(url);
  }

  getLocations(): Observable<Array<string>> {
    let url = this.api_prefix + `/locations`;
    return this.http.get<Array<string>>(url);
  }

}

